import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm, change } from 'redux-form';

import Button from '../../Button';
import Paragraph from '../../Paragraph';
import Heading from '../../Heading';
import { Row } from '../Scaffold';
import { renderField } from '../../Inputs';
import UpdateAuditC from '../../../Actions/Register/updateAuditC';
import Progress from '../../Progress';

const required = value => (value || typeof value === 'number' ? undefined : 'Required');

class AlcoholAuditC extends React.PureComponent {
  state = {
    answered: 0,
    scrollTop: false,
  };

  componentWillMount() {
    this.updateScore();
  }

  componentDidMount() {
    if (window.pageYOffset > this.sectionRef.offsetTop) {
      window.scrollTo({ top: this.sectionRef.offsetTop, behavior: 'smooth' });
    }
  }

  componentDidUpdate(prevProps) {
    if (JSON.stringify(this.props.auditc) !== JSON.stringify(prevProps.auditc)) {
      this.updateScore();
    }
  }

  updateScore(o) {
    const lState = { ...this.props.auditc };

    lState.score = 0;
    lState.showMessage = 0;
    lState.answered = 0;

    if (lState.no_of_drinks) {
      lState.answered += 1;
      switch (lState.no_of_drinks) {
        case '01-02':
        case '1-2':
          lState.score += 0;
          lState.showMessage += 1;
          break;
        case '03-04':
        case '3-4':
          lState.score += 1;
          lState.showMessage += 1;
          break;
        case '5-6':
        case '05-06':
          lState.score += 2;
          lState.showMessage += 1;
          break;
        case '07-09':
        case '7-9':
          lState.score += 3;
          lState.showMessage += 1;
          break;
        case '10+':
          lState.score += 4;
          lState.showMessage += 1;
          break;
        default:
      }
    }

    if (lState.six_or_more) {
      lState.answered += 1;
      switch (lState.six_or_more.toLowerCase()) {
        case 'never':
          lState.showMessage += 1;
          break;
        case 'less than monthly':
          lState.score += 1;
          lState.showMessage += 1;
          break;
        case 'monthly':
          lState.score += 2;
          lState.showMessage += 1;
          break;
        case 'weekly':
          lState.score += 3;
          lState.showMessage += 1;
          break;
        case 'daily or almost daily':
          lState.score += 4;
          lState.showMessage += 1;
          break;
        default:
      }
    }

    if (lState.drink_frequency) {
      lState.answered += 1;
      switch (lState.drink_frequency.toLowerCase()) {
        case 'never':
          lState.showMessage += 1;
          break;
        case 'monthly or less':
          lState.score += 1;
          lState.showMessage += 1;
          break;
        case '2-4 times per month':
          lState.score += 2;
          lState.showMessage += 1;
          break;
        case '2-3 times per week':
          lState.score += 3;
          lState.showMessage += 1;
          break;
        case '4+ times per week':
          lState.score += 4;
          lState.showMessage += 1;
          break;
        default:
      }
    }

    if (lState.alcohol_unable_to_stop) {
      lState.answered += 1;
      switch (lState.alcohol_unable_to_stop.toLowerCase()) {
        case 'never':
          break;
        case 'less than monthly':
          lState.score += 1;
          break;
        case 'monthly':
          lState.score += 2;
          break;
        case 'weekly':
          lState.score += 3;
          break;
        case 'daily or almost daily':
          lState.score += 4;
          break;
        default:
      }
    }

    if (lState.alcohol_failed_to_do) {
      lState.answered += 1;
      switch (lState.alcohol_failed_to_do.toLowerCase()) {
        case 'never':
          break;
        case 'less than monthly':
          lState.score += 1;
          break;
        case 'monthly':
          lState.score += 2;
          break;
        case 'weekly':
          lState.score += 3;
          break;
        case 'daily or almost daily':
          lState.score += 4;
          break;
        default:
      }
    }

    if (lState.alcohol_morning_drink) {
      lState.answered += 1;
      switch (lState.alcohol_morning_drink.toLowerCase()) {
        case 'never':
          break;
        case 'less than monthly':
          lState.score += 1;
          break;
        case 'monthly':
          lState.score += 2;
          break;
        case 'weekly':
          lState.score += 3;
          break;
        case 'daily or almost daily':
          lState.score += 4;
          break;
        default:
      }
    }

    if (lState.alcohol_guilt) {
      lState.answered += 1;
      switch (lState.alcohol_guilt.toLowerCase()) {
        case 'never':
          break;
        case 'less than monthly':
          lState.score += 1;
          break;
        case 'monthly':
          lState.score += 2;
          break;
        case 'weekly':
          lState.score += 3;
          break;
        case 'daily or almost daily':
          lState.score += 4;
          break;
        default:
      }
    }

    if (lState.alcohol_loss_memory) {
      lState.answered += 1;
      switch (lState.alcohol_loss_memory.toLowerCase()) {
        case 'never':
          break;
        case 'less than monthly':
          lState.score += 1;
          break;
        case 'monthly':
          lState.score += 2;
          break;
        case 'weekly':
          lState.score += 3;
          break;
        case 'daily or almost daily':
          lState.score += 4;
          break;
        default:
      }
    }

    if (lState.alcohol_caused_injury) {
      lState.answered += 1;
      switch (lState.alcohol_caused_injury.toLowerCase()) {
        case 'no':
          break;
        case 'yes, but not in the last year':
          lState.score += 2;
          break;
        case 'yes, during the last year':
          lState.score += 4;
          break;
        default:
      }
    }

    if (lState.alcohol_others_concerned) {
      lState.answered += 1;
      switch (lState.alcohol_others_concerned.toLowerCase()) {
        case 'no':
          break;
        case 'yes, but not in the last year':
          lState.score += 2;
          break;
        case 'yes, during the last year':
          lState.score += 4;
          break;
        default:
      }
    }


    this.setState(lState);


    this.props.dispatch(change('registration', 'assessment[alcohol_score]', lState.score));
  }

  render() {
    const { previousPage, handleSubmit } = this.props;
    return (
      <Row classes="drinking-less" setRef={(sectionRef) => { this.sectionRef = sectionRef; }}>
        <Progress step="alcohol" />
        <Paragraph center>
          <img src="https://livewelldorset.s3.amazonaws.com/Pathways/drink-less.png" alt="" width="100" height="100" />
        </Paragraph>
        <Heading classes="header-text yellow" center><span id="register9">Drink less</span></Heading>
        <Paragraph classes="width-limited" center>Many alcohol-related health risks {"don't"} appear until later in life.</Paragraph>
        <Paragraph classes="width-limited" center>Cutting down on how much alcohol you drink will reduce your risk of developing serious health issues such as cancer, liver or heart disease and could contribute to lowering your blood pressure.</Paragraph>
        <form onSubmit={handleSubmit} className="form-register">
          <div>
            {this.state.answered >= 3 ? [
              <Paragraph classes="section-text" center><strong>How often during the last year have you found that you were not able to stop drinking once you had started?</strong></Paragraph>,
              <Field
                name="assessment[alcohol_unable_to_stop]"
                type="radiogroup"
                component={renderField}
                params={{ dataKey: 'auditCFreqLong', name: 'assessment[alcohol_unable_to_stop]', classes: 'yellow fiveInRow' }}
                validate={[required]}
                centered
                onChange={(e, v) => this.props.dispatch(UpdateAuditC('alcohol_unable_to_stop', v))}
              />,
            ] : null}

            {this.state.answered >= 4 ? [
              <Paragraph classes="section-text" center><strong>How often during the last year have you failed to do what was normally expected of you because of drinking?</strong></Paragraph>,
              <Field
                name="assessment[alcohol_failed_to_do]"
                type="radiogroup"
                component={renderField}
                params={{ dataKey: 'auditCFreqLong', name: 'assessment[alcohol_failed_to_do]', classes: 'yellow fiveInRow' }}
                validate={[required]}
                centered
                onChange={(e, v) => this.props.dispatch(UpdateAuditC('alcohol_failed_to_do', v))}
              />,
            ] : null}

            {this.state.answered >= 5 ? [
              <Paragraph classes="section-text" center><strong>How often during the last year have you needed a first drink in the morning to get yourself going after a heavy drinking session?</strong></Paragraph>,
              <Field
                name="assessment[alcohol_morning_drink]"
                type="radiogroup"
                component={renderField}
                params={{ dataKey: 'auditCFreqLong', name: 'assessment[alcohol_morning_drink]', classes: 'yellow fiveInRow' }}
                validate={[required]}
                centered
                onChange={(e, v) => this.props.dispatch(UpdateAuditC('alcohol_morning_drink', v))}
              />,
             ] : null}

            {this.state.answered >= 6 ? [
              <Paragraph classes="section-text" center><strong>How often during the last year have you had a feeling of guilt or remorse after drinking?</strong></Paragraph>,
              <Field
                name="assessment[alcohol_guilt]"
                type="radiogroup"
                component={renderField}
                validate={[required]}
                centered
                params={{ dataKey: 'auditCFreqLong', name: 'assessment[alcohol_guilt]', classes: 'yellow fiveInRow' }}
                onChange={(e, v) => this.props.dispatch(UpdateAuditC('alcohol_guilt', v))}
              />,
            ] : null}

            {this.state.answered >= 7 ? [
              <Paragraph classes="section-text" center><strong>How often during the last year have you been unable to remember what happened the night before because of your drinking?</strong></Paragraph>,
              <Field
                name="assessment[alcohol_loss_memory]"
                type="radiogroup"
                component={renderField}
                params={{ dataKey: 'auditCFreqLong', name: 'assessment[alcohol_loss_memory]', classes: 'yellow fiveInRow' }}
                onChange={(e, v) => this.props.dispatch(UpdateAuditC('alcohol_loss_memory', v))}
                validate={[required]}
                centered
              />,
             ] : null}

            {this.state.answered >= 8 ? [
              <Paragraph classes="section-text" center><strong>Have you or someone else been injured because of your drinking?</strong></Paragraph>,
              <Field
                name="assessment[alcohol_caused_injury]"
                type="radiogroup"
                component={renderField}
                params={{ dataKey: 'auditCRisk', name: 'assessment[alcohol_caused_injury]', classes: 'yellow threeInRow' }}
                validate={[required]}
                centered
                onChange={(e, v) => this.props.dispatch(UpdateAuditC('alcohol_caused_injury', v))}
              />,
            ] : null}

            {this.state.answered >= 9 ? [
              <Paragraph classes="section-text" center><strong>Has a relative, friend, doctor or other health care worker been concerned about your drinking or suggested you cut down?</strong></Paragraph>,
              <Field
                name="assessment[alcohol_others_concerned]"
                type="radiogroup"
                component={renderField}
                validate={[required]}
                centered
                params={{ dataKey: 'auditCRisk', name: 'assessment[alcohol_others_concerned]', classes: 'yellow threeInRow' }}
                onChange={(e, v) => this.props.dispatch(UpdateAuditC('alcohol_others_concerned', v))}
              />,
            ] : null}

            {this.state.answered >= 10 ? [
              <Paragraph classes="section-text" center><strong>Would you like help with this?</strong></Paragraph>,
              <Field name="pathway_alcohol" type="radiogroup" params={{ dataKey: 'LeaveMessage', classes: 'yellow textUppercase' }} component={renderField} centered />,
            ] : null}
          </div>
          <Field name="assessment[alcohol_score]" type="hidden" component={renderField} />

          <Paragraph classes="button-groups divideline" center>
            <Button classes={['color-button yellow']} label="Next" onClick={handleSubmit} />
            <Button classes={['underline-button']} label="Back" onClick={previousPage} />
          </Paragraph>
        </form>
      </Row>
    );
  }
}

AlcoholAuditC.propTypes = {
  previousPage: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  auditc: PropTypes.object.isRequired,
};

const AuditForm = connect(state => ({
  auditc: state.auditc || {},
}))(AlcoholAuditC);

export default reduxForm({
  form: 'registration', // <------ same form name
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  // validate,
})(AuditForm);



// WEBPACK FOOTER //
// ./src/Components/Register/FormPages/AlcoholAuditC.jsx